import masterDashboardPage from "../../Images/master-dashboard-new-2-1.png";
import dashboard2 from "../../Images/Dashboard_ home screen2.png";

const DashboardContent = () => {
  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-3xl font-semibold text-blue-800 mb-6">DASHBOARD</h1>
      <img src={masterDashboardPage} className="size-2/3" />
      <p>
        Once you have successfully logged in, the SecurWeave HIDS dashboard
        offers an intuitive user interface designed to provide critical
        information at a glance and allow easy access to the system’s various
        features. Below is a guide to help you navigate the different sections
        of the dashboard efficiently.
      </p>

      <img src={dashboard2} className="size-2/3" />

      <b> Main Navigation Bars</b>
      <p>
        At the top of the dashboard, you will find the Main Navigation Bar. This
        provides access to the different sections and tools available in the
        system. Typical options include:
      </p>
      <ol className="flex flex-col gap-4">
        <li>
          <b>Dashboard:</b> This is your homepage after logging in. It provides
          a real-time overview of system health, alerts, and performance.
        </li>
        <li>
          <b>System View: </b> This section offers detailed information on each
          system being monitored by HIDS. You can view system-specific alerts,
          performance metrics, and status.
        </li>
        <li>
          <b>Reports:</b> The Reports section allows you to generate and view
          detailed security reports on detected intrusions, system
          vulnerabilities, or events over a specific period.
        </li>
        <li>
          <b>Configuration: </b> This section is where you can customize and
          adjust system settings, configure alert thresholds, and manage
          monitoring rules for your systems.
        </li>
        <li>
          <b>Console:</b> This section is used to find the data using query
          using the level,id,ip,group and pci_dss and other.
        </li>
      </ol>
    </div>
  );
};

export default DashboardContent;
